<template>
  <div class="appointment_main">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <el-date-picker
          v-model="timeValue"
          type="daterange"
          :picker-options="pickerOptions2"
          size="small"
          unlink-panels
          @change="changeTimeValue"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </div>
      <input-search placeholder="房间号" @search="searchKey" />
    </div>
    <!--<div class="search-line">-->
      <!--<div class="btn-box">-->
        <!---->
      <!--</div>-->
      <!--<button-confirm-next value="看房申请" @confirm="showWindowLeftBox" style="margin-left: 5px;" />-->
    <!--</div>-->
    <table-main :selection="false" :tableHead="tableHead" @changeSelection="changeSelection" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :hasOperation="false" />

    <el-dialog
      :visible.sync="dialogVisible"
      width="40%">
      <img :src="lookOverImg" alt="" style="width: 90%;margin: 0 auto;">
    </el-dialog>

    <div>
      <transition name="right-slide">
        <div class="window-left-box" v-show="windowLeftBox">
          <div class="window-left-main">

            <div class="search-line" style="margin: 10px 0">
              <div class="btn-box">

              </div>
              <input-search placeholder="姓名/手机号" @search="windowLeftSearch"/>
            </div>
            <div>
              <table-main :selection="false" :tableHead="windowLeftTableHead" :tableData="windowLeftTableData" :total="windowLeftTotal" :pageNum="windowLeftPageNum" :pageSize="windowLeftPageSize" :hasOperation="false" @changePagination="changeWindowLeftPagination" :row-click="windowLeftRowClick" />
            </div>
          </div>
          <div class="mask" @click.capture.stop="windowLeftBox = !windowLeftBox"></div>
        </div>
      </transition>
    </div>

  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import InputSearch from "../../../components/Input/InputSearch";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/agent";
import { errorHandler } from "../../../utils/errorHandler";
import ButtonConfirmNext from "../../../components/Button/ButtonConfirmNext";
import { nAlert, nSuccess } from "../../../utils/notice";
import ButtonAdd from "../../../components/common/buttons/button-add";
import ButtonDelete from "../../../components/Button/ButtonDelete";

export default {
  components: {
    ButtonAdd,
    ButtonDelete,
    ButtonConfirmNext,
    TableMain,
    InputSearch,
    Breadcrumb,
  },
  name: "agent-manage",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧经纪",
          name: "investment-manage",
        },
        {
          value: "预约记录",
        },
      ],
      tableHead: [
        {
          prop: "personName",
          label: "预约人姓名",
        },
        {
          prop: "personPhone",
          label: "预约人手机",
        },
        {
          prop: "accompanyingPeopleNumber",
          label: "看房人数",
        },
        {
          prop: "roomInfoNumber",
          label: "房间号",
        },
        {
          prop: "statusText",
          label: "预约状态",
          showColor: true,
        },
        {
          prop: "visitStartTime",
          label: "预约时间",
        },
        {
          prop: "visitEndTime",
          label: "离开时间",
        },
      ],
      tableData: [],
      operationArr: ["cancelRelease"],
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() > new Date((new Date() / 1000 + 86400) * 1000);
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      total: 0,
      pageSize: 10,
      pageNum: 1,
      timeValue: [],
      requestData: {
        pageNum: 1,
        pageSize: 10,
        startTime: "",
        endTime: "",
        searchKey: "",
      },
      visitorVisible: false,
      visitorHead: [
        {
          prop: "name",
          label: "经纪人姓名",
        },
        {
          prop: "phone",
          label: "经纪人手机号",
        },
        {
          prop: "enterpriseName",
          label: "经纪人住户",
        },
        {
          prop: "areaInfo",
          label: "所在区域",
        },
        {
          prop: "primaryArea",
          label: "主营商圈",
        },
        {
          prop: "weChatNumber",
          label: "微信号",
        },
        {
          prop: "picUrl",
          label: "经纪人头像",
          isLookOver: true,
        },
      ],
      visitorList: [],
      lookOverImg: "",
      dialogVisible: false,

      windowLeftBox: false,
      windowLeftTableHead: [
        {
          prop: "personName",
          label: "经纪人姓名",
        },
        {
          prop: "personPhone",
          label: "经纪人手机号",
        },
        {
          prop: "enterpriseName",
          label: "经纪人住户",
        },
        {
          prop: "areaInfo",
          label: "所在区域",
        },
        {
          prop: "primaryArea",
          label: "主营商圈",
        },
        {
          prop: "weChatNumber",
          label: "微信号",
        },
      ],
      windowLeftTableData: [],
      windowLeftSearchKey: "",
      windowLeftTotal: 0,
      windowLeftPageNum: 1,
      windowLeftPageSize: 10,
      drawer: false,
      drawerPersonData: {},

      selectionArr: [],
    };
  },
  created() {
    this.getCreatTime();
  },
  activated() {
    this.getPage()
  },
  methods: {
    toAddPage() {
      this.$router.push({
        name: "agent-house-add",
      });
    },
    getCreatTime() {
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      // let hour = nowDate.getHours() < 10 ? '0' + nowDate.getHours() : nowDate.getHours()
      // let minute = nowDate.getMinutes() < 10 ? '0' + nowDate.getMinutes() : nowDate.getMinutes()
      // let second = nowDate.getSeconds() < 10 ? '0' + nowDate.getSeconds() : nowDate.getSeconds()
      this.timeValue[0] = year + "-" + month + "-01";
      this.timeValue[1] = year + "-" + month + "-" + date;
      this.getPage();
    },
    changeTimeValue() {
      this.pageNum = 1;
      this.pageSize = 10;
      this.getPage();
    },
    getPage() {
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      if (this.timeValue.length > 0) {
        reqData.startTime = `${this.timeValue[0]} 00:00:00`;
        reqData.endTime = `${this.timeValue[1]} 23:59:59`;
      }
      this.$axios
        .post(api.getPageApplyVisitPark, reqData)
        .then((res) => {
          let list = res.data.data.list;
          this.total = res.data.data.total;
          list.map((v) => {
            v.picUrl = v.personPic;
            if (v.status === "REJECT") {
              v.statusText = "已驳回";
              v.fontColorToPeople = "#B22222";
            } else if (v.status === "PASS") {
              v.statusText = "已通过";
              v.fontColorToPeople = "#44C23B";
            } else {
              v.statusText = "待审批";
              v.fontColorToPeople = "#999999";
            }
          });
          this.tableData = list;
        })
        .catch(errorHandler("获取失败"));
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },

    lookOver(imgUrl) {
      this.lookOverImg = imgUrl;
      this.dialogVisible = true;
    },

    changeWindowLeftPagination(data) {
      this.windowLeftPageNum = data[0];
      this.windowLeftPageSize = data[1];
      this.getPageApply();
    },

    // 展示人员申请
    showWindowLeftBox() {
      this.windowLeftBox = true;
      this.getPageApply();
    },

    // 返回
    personDataToWindowLeft() {
      this.drawer = false;
      this.windowLeftBox = true;
    },

    // 点击人员查看详情
    windowLeftRowClick(row, event, column) {
      this.windowLeftBox = false;
      this.drawer = true;
      this.drawerPersonData = row;
      // this.getPersonBaklogByCode(row.baklogCode)
    },

    windowLeftSearch(v) {
      this.windowLeftPageNum = 1;
      this.windowLeftSearchKey = v;
      this.getPageApply();
    },

    handleClose(done) {
      done();
      this.windowLeftBox = true;
    },

    // 查询经纪人申请列表
    getPageApply() {
      this.$axios
        .post(api.getPageApply, {
          appointmentStatus: "0",
          pageNum: this.windowLeftPageNum,
          pageSize: this.windowLeftPageSize,
          searchKey: this.windowLeftSearchKey,
        })
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              v.yqPicUrl = v.visitorPic;
            });
            this.windowLeftTotal = res.data.data.total;
            this.windowLeftTableData = data;
          }
        })
        .catch(errorHandler("获取申请列表失败"));
    },

    // 同意申请
    confirmApprove() {
      this.$axios
        .post(`${api.passTheVisitor}`, this.drawerPersonData)
        .then((res) => {
          if (res.data.retCode === 1) {
            nSuccess("操作成功");
            this.drawer = false;
            this.windowLeftBox = true;
            this.getPageApply();
          }
        })
        .catch(errorHandler("操作失败"));
    },

    // 驳回申请
    rejectApprove() {
      let drawerPersonData = this.drawerPersonData;
      drawerPersonData.unApproveReason = this.unApproveReason;
      this.$axios
        .post(`${api.notPassTheVisitor}`, drawerPersonData)
        .then((res) => {
          if (res.data.retCode === 1) {
            nSuccess("操作成功");
            this.drawer = false;
            this.windowLeftBox = true;
            this.approveDialog = false;
            this.getPageApply();
          }
        })
        .catch(errorHandler("操作失败"));
    },
  },
  watch: {},
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.appointment_main {
  .el-dialog .el-dialog__body .el-table .has-gutter th:first-child {
    /*width: 50%!important;*/
  }

  .right-slide-enter,
  .right-slide-leave-active {
    transform: translateX(100%);
  }

  .right-slide-leave-active,
  .right-slide-enter-active {
    transition: all 0.3s;
  }
  .window-left-box {
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    width: 60%;
    z-index: 10;
  }
  .window-left-box .move-enter-active,
  .window-left-box .move-leave-active {
    transition: all 2s linear;
    transform: translate3d(0, 0, 0);
  }
  .window-left-box .move-enter,
  .window-left-box .move-leave {
    transform: translate3d(100%, 0, 0);
  }
  .window-left-main {
    width: 100%;
    height: 100%;
    z-index: 30;
    background: #ffffff;
    padding: 5px 10px;
    overflow: auto;
  }

  .mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    opacity: 0.4;
    z-index: -1;
    background-color: #000000;
    transition: opacity 0.5s ease;
  }

  form {
    width: 450px;
    margin: 0 auto;
    text-align: left;
  }
  .form-line {
    margin: 25px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .line-text {
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
    width: 100px;
    display: flex;
    justify-content: space-between;
  }
  .line-info {
    width: 220px;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin: 40px auto 0;
    display: flex;
    justify-content: space-between;
  }

  .person-management-drawer {
    .el-icon-back {
      margin: 20px 20px 10px;
      display: block;
      border: 0;
      font-size: 20px;
      background-color: #ffffff;
      cursor: pointer;
    }
    .el-icon-back:hover {
      color: #00a0e6;
    }
    .all-table-class .el-table td {
      padding: 10px 0;
    }
    form {
      position: relative;
      .drawerPersonImg {
        position: absolute;
        right: 0;
        top: 0;
        width: 120px;
      }
      .noDrawerPersonImg {
        position: absolute;
        right: 0;
        top: 0;
        width: 120px;
        height: 150px;
        line-height: 160px;
        border: 1px dashed #dcdfe6;
        text-align: center;
        color: #999999;
      }
    }
  }
  .drawerBtnBox {
    width: 360px;
    padding-right: 60px;
    margin: 0 auto;
    .btn-confirm {
      border: 0;
      color: #fff;
      padding: 8px 16px;
      background-color: #00a0e6;
      border-radius: 4px;
      margin-right: 60px;
    }
    .btn-confirm:hover {
      color: #fff;
      background-color: #06b3ff;
    }
    .reject-button {
      border: 0;
      background-color: #f25721;
      color: #ffffff;
      border-radius: 4px;
    }
    .reject-button:hover {
      background-color: #f96e3d;
    }
  }
}

.el-dialog__body {
  .el-table .cell {
    text-align: center;
  }
  .el-table th > .cell {
    color: #48576a;
    font-weight: bold;
  }
}
.el-dialog {
  .el-dialog .el-dialog__body .el-table__empty-block {
    margin: 0 auto;
  }
  .el-table__empty-text {
    width: auto;
  }
  .el-dialog__header {
    text-align: center;
  }
  .el-dialog__body {
    .el-table th:first-child {
      width: auto !important;
    }
  }
}
.btn-box {
  .el-date-editor .el-range-separator {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Agent/agentApply/agentApply.vue